const initialStateAgentLedState = {
  // FIXME: Temporary true for dev mode
  isAgentLedJourney: false,
  isCustomerSSOJourney: false,
  agentLedJourneyCustomerData: {
    section: '',
    agentId: 0,
    merchantId: 0,
    merchantName: '',
    source: '',
    src: '',
    origin: '',
  },
  validateSSOTokenAPICall: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    response: {},
  },
};

export default initialStateAgentLedState;
